export default "__VITE_ASSET__DAHGAt5g__"